import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MigrationExpertComponent } from './sp-migration-expert.component';
import { CoreModule } from 'src/app/core/core.module';
import { FormsModule } from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { MigrationExpertRoutingModule } from '../sp-migration-expert/sp-migration-expert-routing.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    NgbModule,
    MigrationExpertRoutingModule,
  ],
  declarations: [
    MigrationExpertComponent
  ],
  exports: [],
  providers:[DatePipe],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class SpMigrationExpertModule { }
